import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../global/env';
import { FidusVisionData, VisionAwareData } from '../model/visionaware';

const fetchVisionAware = async (timeRange: string): Promise<FidusVisionData> => {
    const paramOperator = Config.demoEnabled ? "?" : "";
    const apiURL = Config.apiBaseURL + Config.fidusVisionURL + `${paramOperator}/${timeRange}/${Config.defaultZone}`
    const { data } = await axios.get(apiURL);
    return data;
}

const useVisionAware = (timeRange: number = 30) => {
    return useQuery<FidusVisionData, Error>(['visionaware', timeRange.toString()], () => fetchVisionAware(timeRange.toString()))
}

export default useVisionAware;